const translates = {
	en: {
		options: ['Process all', 'Process blurring', 'Process smth else'],
	},
	ru: {
		options: ['Считать все', 'Считать blurring', 'Считать что-то еще'],
	}
};
export default translates;